import styled from '@emotion/styled';

// Label/value rows and sections for the right-hand detail sliders (gifts,
// schedules, dispute records), matching TransactionDetailSlider's look.

export const Row: React.FC<{ label: string; children: React.ReactNode }> = ({ label, children }) => (
  <DetailRow>
    <DetailLabel>{label}</DetailLabel>
    <DetailValue>{children}</DetailValue>
  </DetailRow>
);

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 20px;
  border-bottom: 1px solid #E2DED3;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #5D665F;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const Heading = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #0E1A13;
  word-break: break-all;
`;

export const Muted = styled.div`
  font-size: 12px;
  color: #5D665F;
`;

export const LoadingText = styled.div`
  color: #5D665F;
  font-size: 14px;
`;

export const NoteInput = styled.textarea`
  border: 1px solid #E2DED3;
  border-radius: 6px;
  padding: 10px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  & > button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Three columns: what happened, the change, when.
export const EventRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr 1fr;
  gap: 8px;
  font-size: 12px;
  color: #3F4A42;

  & > span:last-of-type {
    text-align: right;
  }
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #0B7A5A;
  font-size: inherit;
  text-align: left;
  cursor: pointer;
  text-decoration: underline;
`;

const DetailRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
`;

const DetailLabel = styled.span`
  color: #5D665F;
`;

const DetailValue = styled.span`
  color: #0E1A13;
  font-weight: 500;
  text-align: right;
  word-break: break-all;
`;
